import { useSalesMarketingApi } from "./useSalesMarketingApi";
import qs from "qs";
import {
    RootVoucherGelAllResponse,
    RootVoucherGetSingleResponse,
    VoucherAdvancedFilters,
    VoucherInputGetAll
} from "../page/voucher/VoucherInterfaces";
import {
  CustomerInputGetAll,
  RootCustomerGetAllResponse,
} from "../interfaces/Customer";
import { VOUCHER_PROVIDER_AMAZON } from "../component/Constants";
import dayjs from "dayjs";

export const useVoucherActions = () => {
  const { GET, POST, PUT } = useSalesMarketingApi();

  async function getVoucherList(filters: VoucherInputGetAll) {
    let provider = filters.providers ? filters.providers : undefined;
    const isProviderAmazon = provider && provider.includes(VOUCHER_PROVIDER_AMAZON);

    let isCustomerAssociated = isProviderAmazon && filters.isCustomerAssociated ? filters.isCustomerAssociated : undefined;
    let isAmazonBusiness = isProviderAmazon && filters.isAmazonBusiness ? filters.isAmazonBusiness : undefined;
    let amazonInvoiceStatus = isProviderAmazon && filters.amazonInvoiceStatus ? filters.amazonInvoiceStatus : undefined;

    let createdDateFrom: Date | null | undefined = filters.createdDateFrom;
    let createdDateTo: Date | null | undefined   = filters.createdDateTo;
    let lastModifiedDateFrom: Date | null | undefined  = filters.lastModifiedDateFrom;
    let lastModifiedDateTo: Date | null | undefined  = filters.lastModifiedDateTo;

    let params = {
      tenantId: filters.legalEntity ? filters.legalEntity : undefined,
      dealerId: filters.dealer ? filters.dealer : undefined,
      status: filters.statuses ? filters.statuses : undefined,
      subName: filters.subName ? filters.subName : undefined,
      code: filters.voucherCode ? filters.voucherCode : undefined,
      bookingCode: filters.bookingNumber ? filters.bookingNumber : undefined,
      provider: provider,
      subCategory: filters.subCategory ? filters.subCategory : undefined,
      search: filters.search ? filters.search : undefined,
      offset: filters.offset ? filters.offset : undefined,
      limit: filters.limit ? filters.limit : undefined,
      sort: filters.sort ? filters.sort : undefined,
      order: filters.order ? filters.order : undefined,
      isCustomerAssociated,
      isAmazonBusiness,
      amazonInvoiceStatus,
      createdDateFrom: createdDateFrom ? createdDateFrom : null,
      createdDateTo: createdDateTo ?  createdDateTo : null,
      lastModifiedDateFrom: lastModifiedDateFrom ? lastModifiedDateFrom : null,
      lastModifiedDateTo: lastModifiedDateTo ? lastModifiedDateTo: null,
      bpCode: filters.bpCode ? filters.bpCode : undefined
    };
    let voucherGetAllResponse: RootVoucherGelAllResponse = await GET(
      "sm/voucher/",
      true,
      {
        params,
        paramsSerializer: (params: VoucherInputGetAll) =>
          qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
      }
    );
    return {
      totalElements: voucherGetAllResponse?.result?.totalElements,
      content: voucherGetAllResponse?.result?.content,
    };
    /* return {
              totalElements: 4,
              content: [
                {"tenantId": "drivalia_it", "dealerId": "275" , "id":"1","voucherCode": "405-8634683-1669952", "subscription": "FlexRent 90 Next","bookingNumber":"xxxx","price":"xx","provider":"Amazon","category":"yiugkjblkuhv","creditNote":"yiuygkjljuk","status":"Used","invoice":"iugkjblnjihl-222","refund":true,"refundDate":"21/12/12"},
                {"tenantId": "drivalia_it", "dealerId": "207" , "id":"2","voucherCode": "405-8634683-1669555", "subscription": "FlexRent 50 Next","bookingNumber":"xxxx","price":"xx","provider":"Amazon","category":"yiugkjblkuhv","creditNote":"yiuygkjljuk","status":"Refunded","refund":true,"refundDate":"21/03/22"},
                {"tenantId": "drivalia_it", "dealerId": "208" , "id":"3","voucherCode": "405-8634683-1669555", "subscription": "FlexRent 50 Next","bookingNumber":"xxxx","price":"xx","provider":"Mobility","category":"yiugkjblkuhv","creditNote":"yiuygkjljuk","status":"Available","invoice":"iugkjblnjihl-342","refund":false,"refundDate":""},
                {"id":"4","tenantId": "drivalia_it", "dealerId": "drivalia","status":"EXPIRED","voucherCode":"123-iugdkjk","subscription":"FlexGo Rent","sku":"56789","price":"50","bookingDate":"23/12/65","amazonBookingStatus":"OK","amazonMail":"amazon@amazon.com","invoice":"iugyfjhkl","provider":"amazon","refundDate":"12/02/23","creditNoteNumber":"324","creditNumberDate":"12/12/98","note":"opunjlkiu"}
                ]
          } */
  }

  async function getVoucherById(id: string) {
    let data: RootVoucherGetSingleResponse = await GET(
      "sm/voucher/" + id,
      true
    );
    return data?.result;
    /* return getVoucherList({}).then(res => res.content.find(voucher => voucher.id === id)); */
  }

  async function updateVoucher(payload: any) {
    return await PUT("sm/voucher/", payload, true);
  }

  async function downloadInvoice(invoiceId: number) {
    return await GET(`sm/fnn/pdf-invoice/${invoiceId}`, false);
  }

    async function exportVoucherList(filters:VoucherAdvancedFilters){
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            status: filters.statuses ? filters.statuses : undefined,
            subName:filters.subName ? filters.subName : undefined,
            code:filters.voucherCode ? filters.voucherCode : undefined,
            bookingCode:filters.bookingNumber ? filters.bookingNumber : undefined,
            provider:filters.providers ? filters.providers : undefined,
            subCategory:filters.subCategory ? filters.subCategory : undefined,
        };
        return await GET(`sm/voucher/get-all-to-excel-b64`,true,{
            params,
            paramsSerializer: (params: VoucherAdvancedFilters) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        })
    }

    async function downloadTemplate(){
        return await GET("sm/voucher/template.xlsx", true, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/vnd.ms-excel'
            }
        });
    }

    async function importFile(file: File, tenantId: string, dealerId : string) {
        let formData = new FormData();
        formData.append("file", file);
        return await POST(`sm/voucher/upload-excel?tenant_id=${tenantId}&dealer_id=${dealerId}`, formData, true, {headers: {"Content-Type": "multipart/form-data"}})
    }


    async function getCustomer(filters: CustomerInputGetAll) {
        let params = {
            taxCode: filters.taxCode ? filters.taxCode : undefined,
            vatNumber: filters.vatNumber ? filters.vatNumber : undefined,
            cbCustomerId: filters.cbCustomerId ? filters.cbCustomerId : undefined,
            email: filters.email ? filters.email : undefined,
            lastName: filters.lastName ? filters.lastName : undefined,
            companyName: filters.companyName ? filters.companyName : undefined,
            start: filters.start ? filters.start : undefined,
            limit: filters.limit ? filters.limit : undefined,
            sortBy: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let voucherGetAllResponse: RootCustomerGetAllResponse = await GET("/sm/customer-base/search", true, {
            params,
            paramsSerializer: (params: CustomerInputGetAll) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
        });
        return {
            totalElements: voucherGetAllResponse?.customFields?.size,
            content: voucherGetAllResponse?.data
        };
    }

    async function getCategoriesBySegmentCode(tenantId?: string) {
        let params = {
            segmentCode: "SUB",//always SUB for subscriptions
            tenantId: tenantId
        }
        let data = await GET("sm/lookup/category-code", false,{params: params});
        return data?.result ? data.result["category-code"] : [];
    }

    return {
        getVoucherList,
        getVoucherById,
        updateVoucher,
        downloadInvoice,
        exportVoucherList,
        downloadTemplate,
        importFile,
        getCustomer,
        getCategoriesBySegmentCode
    };
}